module.exports = __webpack_public_path__ + "img/pressure.b8b3e6b0.png";